import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { UserCountService } from '#services/api/usercount.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from '#services/api';
import { Observable } from 'rxjs';
import { LoadingIndicatorService } from '#services/shared/loading-indicator.service';
import { finalize } from 'rxjs/operators';


@Component({
    selector: 'app-usercountreport',
    templateUrl: './usercountreport.component.html',
    styleUrls: ['./usercountreport.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserCountReportComponent implements OnInit {
  logs: any[];
  queryParams;
  project: Observable<any> = null;

  groupedRoles: { role: string, count: number, users: any[] }[] = [];
  showRoleModal: boolean = false;
  selectedRole: string = '';
  selectedRoleUsers: any[] = [];

  selectedHours = 24; // Default to 24 hours
  selectedRoleFilter: string = '';

  globalFilter: string = '';

  constructor(
    private userCountService: UserCountService,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public loadingIndicatorSvc: LoadingIndicatorService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {

    this.queryParams = this.getQueryParams();

    if(!this.queryParams.projectObjectId) {
      this.router.navigate(['error/not-found']);
    }

    this.project = this.projectService.getProject(this.queryParams.projectObjectId);

   
    const dataUptoHours = 24;
    setTimeout(() => {
      this.ExecuteSearch({
        projectObjectId: this.queryParams.projectObjectId,
        dataUptoHours  
      });
    });
      
  }

  ExecuteSearch(data?) {
        
    data = data ? data : {};
    data.projectObjectId = this.queryParams.projectObjectId;
    this.setQueryParams(data);
    this.loadingIndicatorSvc.show();
    this.userCountService.Query(data)
      .pipe(finalize(() => this.loadingIndicatorSvc.hide()))
      .subscribe(logs => {
        this.logs = logs;
        // Exclude "Scheduler" from group by and individual lists
        const filteredLogs = (logs || []).filter(log => {
          const role = (log.UserRoleText || '').trim().toLowerCase();
          return role !== 'scheduler' &&
                 role !== 'scheduler,company rep' &&
                 role !== 'scheduler,contract foreman' &&
                 role !== 'contract foreman,company rep' &&
                 role !== 'scheduler,contract foreman,company rep';
        });
        const roleMap: { [role: string]: any[] } = {};
        filteredLogs.forEach(log => {
          const role = log.UserRoleText || 'Unknown';
          if (!roleMap[role]) roleMap[role] = [];
          roleMap[role].push(log);
        });
        this.groupedRoles = Object.keys(roleMap).map(role => ({
          role,
          count: roleMap[role].length,
          users: roleMap[role]
        }));
        // groupedRoles feeds template bindings; stabilize the view synchronously
        // to avoid NG0100.
        this.cdr.detectChanges();
      });
  }

  openRoleModal(role: string, users: any[]) {
    this.selectedRole = role;
    // Filter out any "Scheduler" entries just in case
    this.selectedRoleUsers = [...users].filter(
      u => (u.UserRoleText || '').trim().toLowerCase() !== 'scheduler'
    ).sort((a, b) => {
      const aDate = a.CreateDate ? new Date(a.CreateDate) : (a.ModifiedDate ? new Date(a.ModifiedDate) : new Date(0));
      const bDate = b.CreateDate ? new Date(b.CreateDate) : (b.ModifiedDate ? new Date(b.ModifiedDate) : new Date(0));
      return bDate.getTime() - aDate.getTime();
    });
    this.showRoleModal = true;
  }

  closeRoleModal() {
    this.showRoleModal = false;
    this.selectedRole = '';
    this.selectedRoleUsers = [];
  }

  getQueryParams() {
    const qp = this.activatedRoute.snapshot.queryParamMap;
    const projectObjectId = qp.has('projectObjectId')
      ? parseInt(qp.get('projectObjectId'), 10)
      : undefined;
    const activityObjectId = qp.has('activityObjectId')
      ? parseInt(qp.get('activityObjectId'), 10)
      : undefined;
    const dateFrom = qp.has('dateFrom') ? qp.get('dateFrom') : undefined;
    const dateTo = qp.has('dateTo') ? qp.get('dateTo') : undefined;
    return {
      projectObjectId,
      activityObjectId,
      dateFrom,
      dateTo
    };
  }

  setQueryParams(queryData) {
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryData
      });
  }

  onDeltaReportClick() {
    this.router.navigate([''], {queryParams: {projectObjectId: this.queryParams.projectObjectId}});
  }

  onHoursChange(event: any) {
    this.ExecuteSearch({
      projectObjectId: this.queryParams.projectObjectId,
      dataUptoHours: this.selectedHours
    });
  }

  onRoleFilterChange() {
    // No need to do anything if you use a getter for filteredUsers
  }

  get filteredUsers() {
    // Flatten groupedRoles to a single array of users with role info
    const flatUsers = (this.groupedRoles || []).flatMap(group =>
      (group.users || []).map(user => ({
        ...user,
        role: group.role,
        CrewLabel: this.getCrewLabel(user.Type)
      }))
    );
    // Filter by selectedRoleFilter if set
    if (!this.selectedRoleFilter) {
      return flatUsers;
    }
    return flatUsers.filter(user => user.role === this.selectedRoleFilter);
  }

  getCrewLabel(type: string): string {
    if (type === 'Co-Reps') return 'Company Rep';
    if (type === 'Crew-1') return 'Primary Crew';
    if (type === 'Crew-2') return 'Supporting Crew';
    return '';
  }

  getSelectedHoursLabel(): string {
    switch (this.selectedHours) {
      case 168: return '7 days';
      case 720: return '30 days';
      case 1440: return '60 days';
      default: return this.selectedHours + ' hours';
    }
  }
}
